// All site translations for PL / EN / UK
export const LANGUAGES = [
  { code: "pl", label: "PL", name: "Polski" },
  { code: "en", label: "EN", name: "English" },
  { code: "uk", label: "UA", name: "Українська" },
  { code: "es", label: "ES", name: "Español" },
];

export const translations = {
  pl: {
    nav: {
      about: "O Nas",
      services: "Usługi",
      jobs: "Oferty Pracy",
      contact: "Kontakt",
      faq: "FAQ",
      companies: "Dla Firm",
      workers: "Dla Pracowników",
      cta: "Wyślij zapytanie",
    },
    hero: {
      localBadge: "Lokalna agencja pracy z Wrocławia",
      eyebrow: "AGENCJA PRACY TYMCZASOWEJ · OUTSOURCING PROCESOWY",
      title: "Kompleksowe wsparcie kadrowe Twojej firmy",
      subtitle:
        "Pracownicy | anglojęzyczni z Azji i Ameryki Południowej | polskojęzyczni z Bliskiego Wschodu",
      ctaCompany: "Dla Pracodawców",
      ctaWorker: "Szukam Pracy",
    },
    audience: {
      heading: "Jak możemy Ci pomóc?",
      subheading: "Wybierz ścieżkę dopasowaną do Twoich potrzeb.",
      companyTab: "Jestem Pracodawcą",
      workerTab: "Szukam Pracy",
    },
    stats: {
      retention: "93% pracowników pozostaje z nami przez okres pełnych 18 miesięcy",
      retentionLabel: "Retencja pracowników",
      placed: "Pracowników zatrudnionych",
      clients: "Zadowolonych klientów",
      countries: "Rynki rekrutacji",
    },
    about: {
      eyebrow: "O NAS",
      title: "Kim jesteśmy?",
      desc:
        "PSS Group to agencja pracy tymczasowej i partner w outsourcingu procesowym. Bierzemy na siebie pełną odpowiedzialność za personel — od rekrutacji po zakwaterowanie.",
      card1Title: "Globalny zasięg rekrutacji",
      card1Desc:
        "Zapewniamy zmotywowanych, anglojęzycznych pracowników z rynków takich jak Filipiny, Nepal, Kolumbia, a także z Bliskiego Wschodu.",
      card2Title: "Kompleksowa obsługa HR",
      card2Desc:
        "Bierzemy na siebie pełną odpowiedzialność, od procesów kadrowo-płacowych, przez legalizację i logistykę, aż po zakwaterowanie personelu.",
    },
    services: {
      eyebrow: "PSS – GROUP",
      title: "Nasze usługi",
      forCompanies: "Rozwiązania dla Twojej firmy",
      service1Title: "Praca tymczasowa",
      service1Desc:
        "Zatrudniamy pracowników i delegujemy ich do pracy w Twojej firmie. Formalnie są pracownikami Agencji, ale na co dzień poddelegowani Twojemu kierownictwu.",
      service2Title: "Outsourcing procesowy",
      service2Desc:
        "Zlecasz nam cały proces (np. produkcję, pakowanie), a my bierzemy za niego pełną odpowiedzialność. Zarządzamy zespołem i rozliczamy się za efekt, a nie za godziny pracy.",
      service3Title: "Legalizacja i logistyka",
      service3Desc:
        "Kompleksowa legalizacja pobytu i pracy cudzoziemców, transport oraz zakwaterowanie pracowników w jednym miejscu.",
      learnMore: "Dowiedz się więcej",
    },
    jobs: {
      eyebrow: "DLA PRACOWNIKÓW",
      title: "Aktualne oferty pracy",
      subtitle: "Znajdź pracę dopasowaną do Twoich umiejętności i aplikuj w kilka sekund.",
      searchPlaceholder: "Szukaj stanowiska lub miasta...",
      allCategories: "Wszystkie kategorie",
      apply: "Aplikuj teraz",
      type: "Typ",
      location: "Lokalizacja",
      salary: "Wynagrodzenie",
      noResults: "Brak ofert spełniających kryteria.",
      benefitsTitle: "Co oferujemy pracownikom",
      benefit1: "Legalne zatrudnienie i terminowe wypłaty",
      benefit2: "Zakwaterowanie i transport do pracy",
      benefit3: "Wsparcie w legalizacji pobytu",
      benefit4: "Opieka koordynatora w Twoim języku",
    },
    contact: {
      eyebrow: "KONTAKT",
      title: "Napisz do nas - jak możemy Ci pomóc?",
      subtitle: "Wypełnij formularz, a nasz zespół skontaktuje się z Tobą najszybciej jak to możliwe.",
      iAm: "Jestem",
      company: "Pracodawcą",
      worker: "Pracownikiem",
      companyName: "Nazwa firmy",
      companyNamePh: "Firma",
      name: "Osoba kontaktowa",
      namePh: "Imię i nazwisko",
      subject: "Temat zapytania",
      subjectPh: "Temat",
      email: "Email",
      emailPh: "firma@firma.pl",
      phone: "Telefon",
      phonePh: "+48 ...",
      message: "Napisz jak możemy Ci pomóc!",
      messagePh: "Opisz swoją potrzebę, my się skontaktujemy",
      submit: "Wyślij wiadomość",
      sending: "Wysyłanie...",
      success: "Wiadomość została wysłana! Skontaktujemy się wkrótce.",
      error: "Coś poszło nie tak. Spróbuj ponownie.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Najczęściej zadawane pytania",
      subtitle: "Masz pytania dotyczące współpracy? Poniżej zebraliśmy najważniejsze odpowiedzi.",
      items: [
        {
          q: "Czym zajmuje się PSS Group?",
          a: "Jesteśmy agencją pracy tymczasowej oraz partnerem w outsourcingu procesowym. Rekrutujemy, zatrudniamy i delegujemy zmotywowanych pracowników, a także przejmujemy odpowiedzialność za całe procesy, takie jak produkcja czy pakowanie.",
        },
        {
          q: "Dlaczego warto wybrać właśnie PSS Group?",
          a: "Łączymy globalny zasięg rekrutacji z kompleksową obsługą HR — od legalizacji, przez logistykę, aż po zakwaterowanie. Dzięki temu jesteśmy postrzegani jako solidna i najlepsza agencja pracy Wrocław oraz pozostałe regiony Polski mogą polecić partnerom poszukującym sprawdzonych pracowników. 93% naszych pracowników pozostaje z nami przez pełne 18 miesięcy.",
        },
        {
          q: "Z jakich rynków pozyskujecie pracowników?",
          a: "Zapewniamy anglojęzycznych, zmotywowanych pracowników z rynków takich jak Filipiny, Nepal, Kolumbia, a także z Bliskiego Wschodu i Ameryki Południowej.",
        },
        {
          q: "Czy zajmujecie się legalizacją i zakwaterowaniem?",
          a: "Tak. Bierzemy na siebie pełną odpowiedzialność za legalizację pobytu i pracy cudzoziemców, transport oraz zakwaterowanie personelu — wszystko w jednym miejscu.",
        },
        {
          q: "Jak szybko mogę otrzymać pracowników?",
          a: "Po kontakcie poprzez formularz nasz zespół przygotowuje propozycję i harmonogram dopasowany do Twoich potrzeb. Czas zależy od skali i specyfiki zlecenia.",
        },
        {
          q: "Jestem pracownikiem — jak mogę aplikować?",
          a: "Przejdź do zakładki Oferty Pracy, wybierz interesujące Cię stanowisko i kliknij „Aplikuj teraz”. Formularz kontaktowy automatycznie uzupełni temat zapytania.",
        },
      ],
    },
    footer: {
      tagline: "Kompleksowe wsparcie kadrowe i outsourcing procesowy.",
      quickLinks: "Szybkie linki",
      contactInfo: "Kontakt",
      rights: "Wszelkie prawa zastrzeżone.",
      privacy: "Polityka Prywatności",
    },
  },

  en: {
    nav: {
      about: "About",
      services: "Services",
      jobs: "Jobs",
      contact: "Contact",
      faq: "FAQ",
      companies: "For Companies",
      workers: "For Workers",
      cta: "Send inquiry",
    },
    hero: {
      localBadge: "Local work agency from Wrocław",
      eyebrow: "TEMPORARY WORK AGENCY · PROCESS OUTSOURCING",
      title: "Complete HR support for your company",
      subtitle:
        "Workers | English-speaking from Asia and South America | Polish-speaking from the Middle East",
      ctaCompany: "For Employers",
      ctaWorker: "Find a Job",
    },
    audience: {
      heading: "How can we help you?",
      subheading: "Choose the path that fits your needs.",
      companyTab: "I'm an Employer",
      workerTab: "I'm looking for work",
    },
    stats: {
      retention: "93% of our employees stay with us for a full 18 months",
      retentionLabel: "Employee retention",
      placed: "Workers placed",
      clients: "Happy clients",
      countries: "Recruitment markets",
    },
    about: {
      eyebrow: "ABOUT US",
      title: "Who we are?",
      desc:
        "PSS Group is a temporary work agency and a process outsourcing partner. We take full responsibility for staff — from recruitment to accommodation.",
      card1Title: "Global recruitment reach",
      card1Desc:
        "We provide motivated, English-speaking workers from markets such as the Philippines, Nepal, Colombia, and the Middle East.",
      card2Title: "Comprehensive HR service",
      card2Desc:
        "We take full responsibility — from payroll and HR processes, through legalization and logistics, all the way to staff accommodation.",
    },
    services: {
      eyebrow: "PSS – GROUP",
      title: "Our services",
      forCompanies: "Solutions for your company",
      service1Title: "Temporary work",
      service1Desc:
        "We employ workers and delegate them to work at your company. Formally they are Agency employees, but day-to-day they report to your management.",
      service2Title: "Process outsourcing",
      service2Desc:
        "You outsource an entire process (e.g. production, packaging) and we take full responsibility. We manage the team and settle for results, not hours.",
      service3Title: "Legalization & logistics",
      service3Desc:
        "Complete legalization of foreigners' stay and work, transport, and accommodation of workers — all in one place.",
      learnMore: "Learn more",
    },
    jobs: {
      eyebrow: "FOR WORKERS",
      title: "Current job offers",
      subtitle: "Find a job that matches your skills and apply in seconds.",
      searchPlaceholder: "Search position or city...",
      allCategories: "All categories",
      apply: "Apply now",
      type: "Type",
      location: "Location",
      salary: "Salary",
      noResults: "No offers match your criteria.",
      benefitsTitle: "What we offer workers",
      benefit1: "Legal employment and on-time payments",
      benefit2: "Accommodation and transport to work",
      benefit3: "Support with residence legalization",
      benefit4: "A coordinator who speaks your language",
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Write to us - how can we help?",
      subtitle: "Fill in the form and our team will get back to you as soon as possible.",
      iAm: "I am an",
      company: "Employer",
      worker: "Worker",
      companyName: "Company name",
      companyNamePh: "Company",
      name: "Contact person",
      namePh: "Full name",
      subject: "Inquiry subject",
      subjectPh: "Subject",
      email: "Email",
      emailPh: "company@company.com",
      phone: "Phone",
      phonePh: "+48 ...",
      message: "Tell us how we can help!",
      messagePh: "Describe your need and we'll contact you",
      submit: "Send message",
      sending: "Sending...",
      success: "Your message has been sent! We'll contact you soon.",
      error: "Something went wrong. Please try again.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      subtitle: "Have questions about working with us? Here are the most important answers.",
      items: [
        {
          q: "What does PSS Group do?",
          a: "We are a temporary work agency and a process outsourcing partner. We recruit, employ and delegate motivated workers, and we also take responsibility for entire processes such as production or packaging.",
        },
        {
          q: "Why choose PSS Group?",
          a: "We combine a global recruitment reach with comprehensive HR support — from legalization, through logistics, to accommodation. 93% of our employees stay with us for a full 18 months.",
        },
        {
          q: "Which markets do you recruit from?",
          a: "We provide motivated, English-speaking workers from markets such as the Philippines, Nepal, Colombia, as well as the Middle East and South America.",
        },
        {
          q: "Do you handle legalization and accommodation?",
          a: "Yes. We take full responsibility for the legalization of foreigners' stay and work, transport, and staff accommodation — all in one place.",
        },
        {
          q: "How quickly can I receive workers?",
          a: "After you contact us via the form, our team prepares a proposal and schedule tailored to your needs. The timeline depends on the scale and specifics of the order.",
        },
        {
          q: "I'm a worker — how can I apply?",
          a: "Go to the Jobs tab, choose a position and click “Apply now”. The contact form will automatically fill in the inquiry subject.",
        },
      ],
    },
    footer: {
      tagline: "Complete HR support and process outsourcing.",
      quickLinks: "Quick links",
      contactInfo: "Contact",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
    },
  },

  uk: {
    nav: {
      about: "Про нас",
      services: "Послуги",
      jobs: "Вакансії",
      contact: "Контакти",
      faq: "FAQ",
      companies: "Для компаній",
      workers: "Для працівників",
      cta: "Надіслати запит",
    },
    hero: {
      localBadge: "Місцева агенція праці з Вроцлава",
      eyebrow: "АГЕНЦІЯ ТИМЧАСОВОЇ РОБОТИ · АУТСОРСИНГ ПРОЦЕСІВ",
      title: "Комплексна кадрова підтримка вашої компанії",
      subtitle:
        "Працівники | англомовні з Азії та Південної Америки | польськомовні з Близького Сходу",
      ctaCompany: "Для роботодавців",
      ctaWorker: "Шукаю роботу",
    },
    audience: {
      heading: "Чим ми можемо допомогти?",
      subheading: "Оберіть напрямок, що відповідає вашим потребам.",
      companyTab: "Я — роботодавець",
      workerTab: "Шукаю роботу",
    },
    stats: {
      retention: "93% наших працівників залишаються з нами протягом повних 18 місяців",
      retentionLabel: "Утримання працівників",
      placed: "Працевлаштовано працівників",
      clients: "Задоволених клієнтів",
      countries: "Ринки підбору",
    },
    about: {
      eyebrow: "ПРО НАС",
      title: "Хто ми?",
      desc:
        "PSS Group — це агенція тимчасової роботи та партнер з аутсорсингу процесів. Ми беремо на себе повну відповідальність за персонал — від підбору до проживання.",
      card1Title: "Глобальний охоплення підбору",
      card1Desc:
        "Ми надаємо мотивованих, англомовних працівників з таких ринків, як Філіппіни, Непал, Колумбія, а також з Близького Сходу.",
      card2Title: "Комплексний HR-сервіс",
      card2Desc:
        "Ми беремо на себе повну відповідальність — від кадрових та платіжних процесів, через легалізацію та логістику, аж до проживання персоналу.",
    },
    services: {
      eyebrow: "PSS – GROUP",
      title: "Наші послуги",
      forCompanies: "Рішення для вашої компанії",
      service1Title: "Тимчасова робота",
      service1Desc:
        "Ми наймаємо працівників і делегуємо їх до роботи у вашій компанії. Формально вони працівники Агенції, але щодня підпорядковуються вашому керівництву.",
      service2Title: "Аутсорсинг процесів",
      service2Desc:
        "Ви передаєте нам цілий процес (напр. виробництво, пакування), а ми беремо за нього повну відповідальність. Ми керуємо командою та звітуємо за результат, а не за години.",
      service3Title: "Легалізація та логістика",
      service3Desc:
        "Повна легалізація перебування та роботи іноземців, транспорт і проживання працівників — все в одному місці.",
      learnMore: "Дізнатися більше",
    },
    jobs: {
      eyebrow: "ДЛЯ ПРАЦІВНИКІВ",
      title: "Актуальні вакансії",
      subtitle: "Знайдіть роботу, що відповідає вашим навичкам, і подайте заявку за секунди.",
      searchPlaceholder: "Пошук посади або міста...",
      allCategories: "Всі категорії",
      apply: "Подати заявку",
      type: "Тип",
      location: "Локація",
      salary: "Зарплата",
      noResults: "Немає вакансій за вашими критеріями.",
      benefitsTitle: "Що ми пропонуємо працівникам",
      benefit1: "Легальне працевлаштування та своєчасні виплати",
      benefit2: "Проживання та транспорт до роботи",
      benefit3: "Підтримка в легалізації перебування",
      benefit4: "Координатор, який розмовляє вашою мовою",
    },
    contact: {
      eyebrow: "КОНТАКТИ",
      title: "Напишіть нам - чим можемо допомогти?",
      subtitle: "Заповніть форму, і наша команда зв'яжеться з вами якнайшвидше.",
      iAm: "Я —",
      company: "Роботодавець",
      worker: "Працівник",
      companyName: "Назва компанії",
      companyNamePh: "Компанія",
      name: "Контактна особа",
      namePh: "Ім'я та прізвище",
      subject: "Тема запиту",
      subjectPh: "Тема",
      email: "Email",
      emailPh: "company@company.com",
      phone: "Телефон",
      phonePh: "+48 ...",
      message: "Напишіть, чим можемо допомогти!",
      messagePh: "Опишіть свою потребу, і ми зв'яжемося з вами",
      submit: "Надіслати повідомлення",
      sending: "Надсилання...",
      success: "Ваше повідомлення надіслано! Ми скоро зв'яжемося.",
      error: "Щось пішло не так. Спробуйте ще раз.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Часті запитання",
      subtitle: "Маєте запитання щодо співпраці? Нижче ми зібрали найважливіші відповіді.",
      items: [
        {
          q: "Чим займається PSS Group?",
          a: "Ми — агенція тимчасової роботи та партнер з аутсорсингу процесів. Ми підбираємо, наймаємо та делегуємо мотивованих працівників, а також беремо на себе відповідальність за цілі процеси, такі як виробництво чи пакування.",
        },
        {
          q: "Чому варто обрати PSS Group?",
          a: "Ми поєднуємо глобальний охоплення підбору з комплексним HR-сервісом — від легалізації, через логістику, до проживання. 93% наших працівників залишаються з нами протягом повних 18 місяців.",
        },
        {
          q: "З яких ринків ви набираєте працівників?",
          a: "Ми надаємо мотивованих, англомовних працівників з таких ринків, як Філіппіни, Непал, Колумбія, а також з Близького Сходу та Південної Америки.",
        },
        {
          q: "Чи займаєтеся ви легалізацією та проживанням?",
          a: "Так. Ми беремо на себе повну відповідальність за легалізацію перебування та роботи іноземців, транспорт і проживання персоналу — все в одному місці.",
        },
        {
          q: "Як швидко я можу отримати працівників?",
          a: "Після звернення через форму наша команда готує пропозицію та графік, адаптований до ваших потреб. Час залежить від масштабу та специфіки замовлення.",
        },
        {
          q: "Я працівник — як подати заявку?",
          a: "Перейдіть до вкладки Вакансії, оберіть посаду та натисніть «Подати заявку». Контактна форма автоматично заповнить тему запиту.",
        },
      ],
    },
    footer: {
      tagline: "Комплексна кадрова підтримка та аутсорсинг процесів.",
      quickLinks: "Швидкі посилання",
      contactInfo: "Контакти",
      rights: "Всі права захищені.",
      privacy: "Політика конфіденційності",
    },
  },

  es: {
    nav: {
      about: "Sobre nosotros",
      services: "Servicios",
      jobs: "Empleos",
      contact: "Contacto",
      faq: "FAQ",
      companies: "Para empresas",
      workers: "Para trabajadores",
      cta: "Enviar consulta",
    },
    hero: {
      localBadge: "Agencia de trabajo local de Wrocław",
      eyebrow: "AGENCIA DE TRABAJO TEMPORAL · EXTERNALIZACIÓN DE PROCESOS",
      title: "Apoyo integral de RR. HH. para tu empresa",
      subtitle:
        "Trabajadores | de habla inglesa de Asia y América del Sur | de habla polaca de Oriente Medio",
      ctaCompany: "Para empresas",
      ctaWorker: "Buscar trabajo",
    },
    audience: {
      heading: "¿Cómo podemos ayudarte?",
      subheading: "Elige el camino que se adapte a tus necesidades.",
      companyTab: "Soy empleador",
      workerTab: "Busco trabajo",
    },
    stats: {
      retention: "El 93% de nuestros empleados permanecen con nosotros durante 18 meses completos",
      retentionLabel: "Retención de empleados",
      placed: "Trabajadores colocados",
      clients: "Clientes satisfechos",
      countries: "Mercados de reclutamiento",
    },
    about: {
      eyebrow: "SOBRE NOSOTROS",
      title: "¿Quiénes somos?",
      desc:
        "PSS Group es una agencia de trabajo temporal y un socio de externalización de procesos. Asumimos la plena responsabilidad del personal, desde el reclutamiento hasta el alojamiento.",
      card1Title: "Alcance global de reclutamiento",
      card1Desc:
        "Proporcionamos trabajadores motivados y de habla inglesa de mercados como Filipinas, Nepal, Colombia y también de Oriente Medio.",
      card2Title: "Servicio integral de RR. HH.",
      card2Desc:
        "Asumimos la plena responsabilidad, desde los procesos de nóminas y RR. HH., pasando por la legalización y la logística, hasta el alojamiento del personal.",
    },
    services: {
      eyebrow: "PSS – GROUP",
      title: "Nuestros servicios",
      forCompanies: "Soluciones para tu empresa",
      service1Title: "Trabajo temporal",
      service1Desc:
        "Empleamos a trabajadores y los delegamos a trabajar en tu empresa. Formalmente son empleados de la Agencia, pero en el día a día responden a tu dirección.",
      service2Title: "Externalización de procesos",
      service2Desc:
        "Nos externalizas un proceso completo (p. ej. producción, embalaje) y asumimos toda la responsabilidad. Gestionamos el equipo y facturamos por resultados, no por horas.",
      service3Title: "Legalización y logística",
      service3Desc:
        "Legalización completa de la estancia y el trabajo de extranjeros, transporte y alojamiento de los trabajadores, todo en un solo lugar.",
      learnMore: "Saber más",
    },
    jobs: {
      eyebrow: "PARA TRABAJADORES",
      title: "Ofertas de empleo actuales",
      subtitle: "Encuentra un trabajo que se ajuste a tus habilidades y postúlate en segundos.",
      searchPlaceholder: "Buscar puesto o ciudad...",
      allCategories: "Todas las categorías",
      apply: "Postular ahora",
      type: "Tipo",
      location: "Ubicación",
      salary: "Salario",
      noResults: "No hay ofertas que coincidan con tus criterios.",
      benefitsTitle: "Lo que ofrecemos a los trabajadores",
      benefit1: "Empleo legal y pagos puntuales",
      benefit2: "Alojamiento y transporte al trabajo",
      benefit3: "Apoyo en la legalización de la residencia",
      benefit4: "Un coordinador que habla tu idioma",
    },
    contact: {
      eyebrow: "CONTACTO",
      title: "Escríbenos - ¿cómo podemos ayudarte?",
      subtitle: "Rellena el formulario y nuestro equipo se pondrá en contacto contigo lo antes posible.",
      iAm: "Soy",
      company: "Empleador",
      worker: "Trabajador",
      companyName: "Nombre de la empresa",
      companyNamePh: "Empresa",
      name: "Persona de contacto",
      namePh: "Nombre y apellidos",
      subject: "Asunto de la consulta",
      subjectPh: "Asunto",
      email: "Email",
      emailPh: "empresa@empresa.com",
      phone: "Teléfono",
      phonePh: "+48 ...",
      message: "¡Cuéntanos cómo podemos ayudarte!",
      messagePh: "Describe tu necesidad y te contactaremos",
      submit: "Enviar mensaje",
      sending: "Enviando...",
      success: "¡Tu mensaje ha sido enviado! Nos pondremos en contacto pronto.",
      error: "Algo salió mal. Inténtalo de nuevo.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Preguntas frecuentes",
      subtitle: "¿Tienes preguntas sobre la colaboración? Aquí están las respuestas más importantes.",
      items: [
        {
          q: "¿A qué se dedica PSS Group?",
          a: "Somos una agencia de trabajo temporal y un socio de externalización de procesos. Reclutamos, empleamos y delegamos trabajadores motivados, y también asumimos la responsabilidad de procesos completos como la producción o el embalaje.",
        },
        {
          q: "¿Por qué elegir PSS Group?",
          a: "Combinamos un alcance global de reclutamiento con un servicio integral de RR. HH.: desde la legalización, pasando por la logística, hasta el alojamiento. El 93% de nuestros empleados permanecen con nosotros durante 18 meses completos.",
        },
        {
          q: "¿De qué mercados reclutáis trabajadores?",
          a: "Proporcionamos trabajadores motivados y de habla inglesa de mercados como Filipinas, Nepal, Colombia, así como de Oriente Medio y América del Sur.",
        },
        {
          q: "¿Os encargáis de la legalización y el alojamiento?",
          a: "Sí. Asumimos la plena responsabilidad de la legalización de la estancia y el trabajo de extranjeros, el transporte y el alojamiento del personal, todo en un solo lugar.",
        },
        {
          q: "¿Con qué rapidez puedo recibir trabajadores?",
          a: "Tras contactarnos a través del formulario, nuestro equipo prepara una propuesta y un calendario adaptados a tus necesidades. El plazo depende de la escala y las particularidades del pedido.",
        },
        {
          q: "Soy trabajador, ¿cómo puedo postularme?",
          a: "Ve a la pestaña Empleos, elige un puesto y haz clic en «Postular ahora». El formulario de contacto rellenará automáticamente el asunto de la consulta.",
        },
      ],
    },
    footer: {
      tagline: "Apoyo integral de RR. HH. y externalización de procesos.",
      quickLinks: "Enlaces rápidos",
      contactInfo: "Contacto",
      rights: "Todos los derechos reservados.",
      privacy: "Política de privacidad",
    },
  },
};
